'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _disciplines = require('../actions/disciplines');

var defaultState = {};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];


    switch (action.type) {
        case _disciplines.actionTypes.FETCH_DISCIPLINES_SUCCEEDED:
            return action.disciplines;
        default:
            return state;
    }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvcmVkdWNlcnMvZGlzY2lwbGluZXMuanMiXSwibmFtZXMiOlsiZGVmYXVsdFN0YXRlIiwic3RhdGUiLCJhY3Rpb24iLCJ0eXBlIiwiYWN0aW9uVHlwZXMiLCJGRVRDSF9ESVNDSVBMSU5FU19TVUNDRUVERUQiLCJkaXNjaXBsaW5lcyJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7O0FBRUEsSUFBTUEsZUFBZSxFQUFyQjs7a0JBRWUsWUFBa0M7QUFBQSxRQUFqQ0MsS0FBaUMsdUVBQXpCRCxZQUF5QjtBQUFBLFFBQVhFLE1BQVc7OztBQUU3QyxZQUFRQSxPQUFPQyxJQUFmO0FBQ0ksYUFBS0MseUJBQVlDLDJCQUFqQjtBQUNJLG1CQUFPSCxPQUFPSSxXQUFkO0FBQ0o7QUFDSSxtQkFBT0wsS0FBUDtBQUpSO0FBTUgsQyIsImZpbGUiOiJkaXNjaXBsaW5lcy5qcyIsInNvdXJjZVJvb3QiOiIvc3JjIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgYWN0aW9uVHlwZXMgfSBmcm9tICcuLi9hY3Rpb25zL2Rpc2NpcGxpbmVzJztcblxuY29uc3QgZGVmYXVsdFN0YXRlID0ge307XG5cbmV4cG9ydCBkZWZhdWx0IChzdGF0ZSA9IGRlZmF1bHRTdGF0ZSwgYWN0aW9uKSA9PiB7XG5cbiAgICBzd2l0Y2ggKGFjdGlvbi50eXBlKSB7XG4gICAgICAgIGNhc2UgYWN0aW9uVHlwZXMuRkVUQ0hfRElTQ0lQTElORVNfU1VDQ0VFREVEOlxuICAgICAgICAgICAgcmV0dXJuIGFjdGlvbi5kaXNjaXBsaW5lcztcbiAgICAgICAgZGVmYXVsdDpcbiAgICAgICAgICAgIHJldHVybiBzdGF0ZTtcbiAgICB9XG59O1xuIl19


//////////////////
// WEBPACK FOOTER
// ./src/client/reducers/disciplines.js
// module id = 2249
// module chunks = 0